/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import parameters from '@jira/servicedesk__customer-service-branding/src/__generated__/GlobalBrandingQuery$parameters.ts';
import type { GlobalBrandingQuery } from '@jira/servicedesk__customer-service-branding/src/__generated__/GlobalBrandingQuery.graphql.ts';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type HelpCenterSettingBrandingAppEntryPointComponent = EntryPointComponent<
	{
		GlobalBrandingQuery: GlobalBrandingQuery;
	},
	{},
	{},
	{} | null
>;

export const helpCenterSettingBrandingAppEntryPoint: EntryPoint<
	HelpCenterSettingBrandingAppEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<HelpCenterSettingBrandingAppEntryPointComponent>(
		/* webpackChunkName: "async-help-center-setting-branding-app" */ './HelpCenterSettingBrandingApp.tsx',
	),
	getPreloadProps: ({
		context: {
			match: {
				params: { helpCenterId },
			},
		},
		tenantContext: { cloudId, activationId },
	}: EntryPointRouteParams) => ({
		queries: {
			GlobalBrandingQuery: {
				parameters,
				variables: {
					cloudId,
					helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`,
				},
				options: {
					fetchPolicy: 'store-or-network' as const,
				},
			},
		},
	}),
});
